import React from 'react';

export const CheckmarkRoundedGreen = () => (
  <g id="g56" transform="scale(45)" strokeWidth="0.02222222">
    <path
      fill="#3bbf00"
      strokeWidth="0.02222222"
      id="path38"
      d="M 0,8 A 8,8 0 0 1 8,0 h 8 a 8,8 0 0 1 8,8 v 8 a 8,8 0 0 1 -8,8 H 8 A 8,8 0 0 1 0,16 Z"
    />
    <path
      fill="#ffffff"
      strokeWidth="0.02222222"
      id="path44"
      d="M 6.4323842,10.98508 5.0315131,12.582067 9.6912586,17.110943 17.876457,8.1112462 16.317232,6.6663523 9.5323332,14.058077 Z"
    />
  </g>
);
